module.exports = {
	"Season 1": {
		"1": {
			"slug": "3d-printing",
			"title": "Introduction to 3D Printing",
			"youtube_id": "BFsxYtXhcLA",
			"producers": {
				"Michael Poley": "https:///twitter.com/michaelpoley",
				"Andrew Chalkley": "https://twitter.com/chalkers",
				"Craig Dennis": "https://twitter.com/craigsdennis"
			},
			"hosts": {
				"Andrew Chalkley": "https://twitter.com/chalkers",
				"Craig Dennis": "https://twitter.com/craigsdennis"
			},
			"editors": {
				"Michael Poley": "https:///twitter.com/michaelpoley"
			},
			"directors": {
				"Michael Poley": "https:///twitter.com/michaelpoley"
			},
			"special_thanks": {
				"Proto Pasta": "https://twitter.com/Proto_pasta",
				"Alex Dick": "https://www.linkedin.com/in/alexander-dick-45984b4",
				"Metro East Community Media": "http://www.metroeast.org/",
				"Portland Community Media": "https://www.pcmtv.org/"
			},
			"tils": [
				{
					"time": 18,
					"message": "Today I learned what 3D Printing is on That Maker Show"
				},
				{
					"time": 53,
					"message": "Today I learned that 3D printers come in all shapes and sizes on That Maker Show"
				},
				{
					"time": 65,
					"message": "Today I learned what an extruder is on That Maker Show"
				},
				{
					"time": 93,
					"message": "Today I learned that 3D printers can print in more than one color and material"
				},
				{
					"time": 107,
					"message": "Today I learned about the '3d printing ink' used in 3D Printers"
				},
				{
					"time": 149,
					"message": "Today I learned that 3D printers should be in well venitaled area"
				},
				{
					"time": 218,
					"message": "Today I learned that you can make computer games characters from @DestinyTheGame with a 3d printer!"
				},
				{
					"time": 256,
					"message": "Today I learned that you can print things bigger on the inside like @bbcdoctorwho's T.A.R.D.I.S!"
				},
				{
					"time": 261,
					"message": "Today I learned that Darth Vader can achieve enlightenment on That Maker Show"
				},
				{
					"time": 281,
					"message": "Today I learned that you can use acetone to smooth ABS prints on That Maker Show"
				},
				{
					"time": 345,
					"message": "Today I learned that you can create practical objects like toothbrush holders from @thingiverse on That Maker Show"
				},
				{
					"time": 345,
					"message": "Today I learned that you can create practical objects like toothbrush holders from @thingiverse on That Maker Show"
				},
				{
					"time": 374,
					"message": "Today I learned improve your 3D printer with your 3D print by making parts from @thingiverse on That Maker Show"
				},
				{
					"time": 515,
					"message": "Today I learned that you can improve exsiting designs like storage containers from @IKEAUSA with a 3D printer"
				},
				{
					"time": 560,
					"message": "Today I learned  people use 3D printers to prototype projects and products"
				},
				{
					"time": 584,
					"message": "Today I learned that you can use @Autodesk123D to create 3D models to 3D print"
				},
				{
					"time": 617,
					"message": "Today I learned you can build your own games console thanks to @videopixil & @ecken on That Maker Show"
				},
				{
					"time": 631,
					"message": "Today I learned you can create enclosures for @Raspberry_Pi with a 3D Printer"
				},
				{
					"time": 648,
					"message": "Today I learned you can 3D print tools to help you design cases from your phone or tablet from @thingiverse"
				},
				{
					"time": 818,
					"message": "Today I learned you can put almost anything in to @thingiverse & get something to print"
				},
				{
					"time": 841,
					"message": "Today I learned what 'supports' are in 3D printing on That Maker Show"
				},
				{
					"time": 964,
					"message": "Today I learned that once you're finished prototyping you can use @shapeways to finished your project"
				},
				{
					"time": 987,
					"message": "Today I learned  that you can design and print jewelery on @shapeways in precious metals!"
				},
				{
					"time": 987,
					"message": "Today I learned  that you can design and print jewelery on @shapeways in precious metals!"
				},
				{
					"time": 1044,
					"message": "Today I learned you can 3D print a massive sword from @DestinyTheGame by @kjdesigns365 on That Maker Show"
				},
				{
					"time": 1132,
					"message": "Today I learned you can 3D print cookie cutters & all-sorts of Christmas goodies on That Maker Show"
				},
				{
					"time": 1199,
					"message": "Today I learned you can 3D print a full-size humanoid robot called @inmoov on That Maker Show"
				},
				{
					"time": 1226,
					"message": "Today I learned you can 3D print prosthetic limbs (@RobohandSA) on That Maker Show"
				},
				{
					"time": 1287,
					"message": "Today I learned you can 3D print a building on That Maker Show"
				},
				{
					"time": 1310,
					"message": "Today I learned you can 3D print with 'funky filaments' like those from @proto_pasta on That Maker Show"
				},
				{
					"time": 1367,
					"message": "Today I learned you can 3D print with carbon fiber, steel, conductive matrials from @proto_pasta on That Maker Show"
				},
				{
					"time": 1388,
					"message": "Today I learned you can 3D print with coffee infused filament from @proto_pasta on That Maker Show"
				},
				{
					"time": 1437,
					"message": "Today I learned that @proto_pasta created a pine scented special edition on That Maker Show"
				},
				{
					"time": 1516,
					"message": "Today I learned that 3D printers like the @monoprice Select Mini start at $200 on That Maker Show"
				},
				{
					"time": 1516,
					"message": "Today I learned that 3D printers like the @monoprice Select Mini start at $200 on That Maker Show"
				},
				{
					"time": 1546,
					"message": "Today I learned on That Maker Show that 3D filament like @hatchbox3d costs around $20+ on @amazon"
				},
				{
					"time": 1622,
					"message": "Today I learned that you can use @Simplify3D to 'slice' prints & get estimates on how much something costs to print"
				},
				{
					"time": 1720,
					"message": "Today I learned that patents stifle innovation and that they are bad on That Maker Show"
				}
			],
			"gallery": [
				{
					"src": "/images/S01E01/thumb/13411656_10103985393112174_4750317151606289866_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13411656_10103985393112174_4750317151606289866_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13415408_10103985392922554_5491415336150154923_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13415408_10103985392922554_5491415336150154923_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13415621_10103985393311774_2135589668464091925_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13415621_10103985393311774_2135589668464091925_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13416869_10103985392812774_2892534306950472597_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13416869_10103985392812774_2892534306950472597_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13416927_10103985392109184_7132369971893906525_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13416927_10103985392109184_7132369971893906525_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13418472_10103985392683034_232301809348096612_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13418472_10103985392683034_232301809348096612_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13422223_10103985392613174_3350689438443425550_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13422223_10103985392613174_3350689438443425550_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13422232_10103985392089224_8656089812220299862_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13422232_10103985392089224_8656089812220299862_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13422236_10103985393142114_7399509878286859773_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13422236_10103985393142114_7399509878286859773_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13422327_10103985392348704_1043787785455866224_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13422327_10103985392348704_1043787785455866224_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13433072_10103985401101164_4462636390768791000_o.jpg",
					"width": 150,
					"height": 1152,
					"aspectRatio": 1.7777777777777777,
					"lightboxImage": {
						"src": "/images/S01E01/large/13433072_10103985401101164_4462636390768791000_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13433250_10103985401106154_3605295482872534765_o.jpg",
					"width": 150,
					"height": 1152,
					"aspectRatio": 1.7777777777777777,
					"lightboxImage": {
						"src": "/images/S01E01/large/13433250_10103985401106154_3605295482872534765_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13433261_10103985392014374_8988220972914846192_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13433261_10103985392014374_8988220972914846192_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13433272_10103985393376644_8392917937127710839_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13433272_10103985393376644_8392917937127710839_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13433273_10103985391869664_4150233423825743357_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13433273_10103985391869664_4150233423825743357_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13442538_10103985393092214_8694700863195033217_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13442538_10103985393092214_8694700863195033217_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13442568_10103985392223954_106694880602144869_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13442568_10103985392223954_106694880602144869_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13475143_10103985392313774_2664769532416493849_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13475143_10103985392313774_2664769532416493849_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13475242_10103985391854694_4793470368750419867_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13475242_10103985391854694_4793470368750419867_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13483060_10103985392598204_1896051960584637473_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13483060_10103985392598204_1896051960584637473_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13483213_10103985393256884_4543280468422348952_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13483213_10103985393256884_4543280468422348952_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13490761_10103985391834734_4429052051471664288_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13490761_10103985391834734_4429052051471664288_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13490797_10103985392478444_71703838803161149_o.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E01/large/13490797_10103985392478444_71703838803161149_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13570174_10104022841500304_104675480_o.jpg",
					"width": 150,
					"height": 84,
					"aspectRatio": 1.776470588235294,
					"lightboxImage": {
						"src": "/images/S01E01/large/13570174_10104022841500304_104675480_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13570362_10104022841879544_1779817464_o.jpg",
					"width": 150,
					"height": 84,
					"aspectRatio": 1.776470588235294,
					"lightboxImage": {
						"src": "/images/S01E01/large/13570362_10104022841879544_1779817464_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13582254_10104022841565174_1463938500_o.jpg",
					"width": 150,
					"height": 84,
					"aspectRatio": 1.776470588235294,
					"lightboxImage": {
						"src": "/images/S01E01/large/13582254_10104022841565174_1463938500_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13582415_10104022841620064_2004322515_o.jpg",
					"width": 150,
					"height": 84,
					"aspectRatio": 1.776470588235294,
					"lightboxImage": {
						"src": "/images/S01E01/large/13582415_10104022841620064_2004322515_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13582421_10104022841470364_1994029258_o.jpg",
					"width": 150,
					"height": 84,
					"aspectRatio": 1.776470588235294,
					"lightboxImage": {
						"src": "/images/S01E01/large/13582421_10104022841470364_1994029258_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13588822_10104022842173954_145516897_o.jpg",
					"width": 150,
					"height": 84,
					"aspectRatio": 1.776470588235294,
					"lightboxImage": {
						"src": "/images/S01E01/large/13588822_10104022842173954_145516897_o.jpg"
					}
				},
				{
					"src": "/images/S01E01/thumb/13589018_10104022841590124_1463462095_o.jpg",
					"width": 150,
					"height": 84,
					"aspectRatio": 1.776470588235294,
					"lightboxImage": {
						"src": "/images/S01E01/large/13589018_10104022841590124_1463462095_o.jpg"
					}
				}
			]
		},
		"2": {
			"slug": "microcontrollers",
			"title": "Introduction to Microcontrollers",
			"youtube_id": "JTDfub5Yj-Y",
			"producers": {
				"Michael Poley": "https:///twitter.com/michaelpoley",
				"Andrew Chalkley": "https://twitter.com/chalkers",
				"Craig Dennis": "https://twitter.com/craigsdennis"
			},
			"hosts": {
				"Andrew Chalkley": "https://twitter.com/chalkers",
				"Craig Dennis": "https://twitter.com/craigsdennis"
			},
			"editors": {
				"Michael Poley": "https:///twitter.com/michaelpoley"
			},
			"directors": {
				"Michael Poley": "https:///twitter.com/michaelpoley"
			},
			"crew": {
				"Adam Bailey": "https://twitter.com/codecxo",
				"Elizabeth Kozup": "https://twitter.com/elizabethkozup"
			},
			"special_thanks": {
				"Metro East Community Media": "http://www.metroeast.org/",
				"Portland Community Media": "https://www.pcmtv.org/"
			},
			"tils": [
				{
					"time": 31,
					"message": "Today I learned the basics of circuits"
				},
				{
					"time": 152,
					"message": "Today I learned about resistors and the need for speed"
				},
				{
					"time": 197,
					"message": "Today I learned about the origin of the term 'bread board'"
				},
				{
					"time": 290,
					"message": "Today I learned why they call it ground in electronics.  #Zeus"
				},
				{
					"time": 290,
					"message": "Today I learned why they call it ground in electronics.  #Zeus"
				},
				{
					"time": 465,
					"message": "Today I learned that the @Arduino was used to prototype the smart watch @Pebble"
				},
				{
					"time": 537,
					"message": "Today I learned about different @Arduino compatible boards, like the super tiny Trinket from @adafruit.  https://learn.adafruit.com/introducing-trinket/introduction"
				},
				{
					"time": 537,
					"message": "Today I learned about different @Arduino compatible boards, like the super tiny Trinket from @adafruit.  https://learn.adafruit.com/introducing-trinket/introduction"
				},
				{
					"time": 792,
					"message": "Today I learned I can easily add GPS to my #maker projects!"
				},
				{
					"time": 792,
					"message": "Today I learned I can easily add GPS to my #maker projects!"
				},
				{
					"time": 1030,
					"message": "Today I learned about a crucial output for time machines.  Thanks @adafruit!"
				},
				{
					"time": 1111,
					"message": "Today I learned that @chalkers is a fun adult toy creator"
				},
				{
					"time": 1286,
					"message": "Today I learned that @adafruit Metro has modified the @Arduino and added a micro USB port. One fewer cable needed!"
				},
				{
					"time": 1286,
					"message": "Today I learned that @adafruit Metro has modified the @Arduino and added a micro USB port. One fewer cable needed!"
				},
				{
					"time": 1362,
					"message": "Today I learned that you can purchase a break out board that will allow you to plug in a @NintendoUSA Wii nunchuck and use it as an input!"
				},
				{
					"time": 1572,
					"message": "Today I learned how to integrate #RFID into an @Arduino using an @adafruit RFID reader shield"
				},
				{
					"time": 1630,
					"message": "Today I learned that you can build devices that can read RFID from things like a @car2go cards or @DisneyInfinity @AmiboNews."
				},
				{
					"time": 2007,
					"message": "Today I learned that you can get started quickly with the awesome mBot robot from @Makeblock. http://www.makeblock.com/mbot-v1-1-stem-educational-robot-kit"
				},
				{
					"time": 2273,
					"message": "Today I learned that the #Arduino based @Intel board the @Arduino 101 has built-in Bluetooth"
				},
				{
					"time": 2317,
					"message": "Today I learned that I could use the @Intel #Arduino 101 to capture them all. #PokemonGo @MarkusJoh"
				},
				{
					"time": 2317,
					"message": "Today I learned that I could use the @Intel #Arduino 101 to capture them all. #PokemonGo @MarkusJoh"
				}
			],
			"gallery": [
				{
					"src": "/images/S01E02/thumb/14022153_10104150404428174_5036592493879755279_n.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E02/large/14086197_10104150404428174_5036592493879755279_o.jpg"
					}
				},
				{
					"src": "/images/S01E02/thumb/14045594_10104150404338354_8111224803867164442_n.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E02/large/13995633_10104150404338354_8111224803867164442_o.jpg"
					}
				},
				{
					"src": "/images/S01E02/thumb/14054176_10104150404493044_7202454027914188222_n.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E02/large/14047194_10104150404493044_7202454027914188222_o.jpg"
					}
				},
				{
					"src": "/images/S01E02/thumb/14055132_10104150403814404_2330566666976743646_n.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E02/large/14103045_10104150403814404_2330566666976743646_o.jpg"
					}
				},
				{
					"src": "/images/S01E02/thumb/14064004_10104150406479064_6701315135466813987_n.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E02/large/13923433_10104150406479064_6701315135466813987_o.jpg"
					}
				},
				{
					"src": "/images/S01E02/thumb/14068088_10104150404078874_1230555302117408338_n.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E02/large/13996321_10104150404078874_1230555302117408338_o.jpg"
					}
				},
				{
					"src": "/images/S01E02/thumb/14100417_10104150404323384_3357151802900529750_n.jpg",
					"width": 150,
					"height": 100,
					"aspectRatio": 1.5003663003663004,
					"lightboxImage": {
						"src": "/images/S01E02/large/14066461_10104150404323384_3357151802900529750_o.jpg"
					}
				}
			]
		},
		"3": {
			"slug": "single-board-computers",
			"title": "Introduction to Single Board Computers",
			"youtube_id": "7kSdPxn0Wq4",
			"producers": {
				"Michael Poley": "https:///twitter.com/michaelpoley",
				"Andrew Chalkley": "https://twitter.com/chalkers",
				"Craig Dennis": "https://twitter.com/craigsdennis"
			},
			"hosts": {
				"Andrew Chalkley": "https://twitter.com/chalkers",
				"Craig Dennis": "https://twitter.com/craigsdennis"
			},
			"editors": {
				"Michael Poley": "https:///twitter.com/michaelpoley"
			},
			"directors": {
				"Michael Poley": "https:///twitter.com/michaelpoley"
			},
			"special_thanks": {
				"Metro East Community Media": "http://www.metroeast.org/"
			},
			"tils": [
				{
					"time": 16,
					"message": "Today I learned what a single board computers is"
				},
				{
					"time": 100,
					"message": "Today I learned that you can install Linux and Windows on a @raspberry_pi"
				},
				{
					"time": 140,
					"message": "Today I learned why the @raspberry_pi is called the Raspberry Pi"
				},
				{
					"time": 180,
					"message": "Today I learned I can just plug a @raspberry_pi to a TV with an HDMI cable"
				},
				{
					"time": 220,
					"message": "Today I learned the @raspberry_pi can be used as a computer and making"
				},
				{
					"time": 242,
					"message": "Today I learned the @raspberry_pi can come in many different sizes"
				},
				{
					"time": 250,
					"message": "Wow, the @raspberry_pi Zero is tiny!"
				},
				{
					"time": 306,
					"message": "Today I learned that some @raspberry_pi have wifi and bluetooth built-in"
				},
				{
					"time": 366,
					"message": "Today I learned that the @raspberry_pi starts at $5! Incredible!"
				},
				{
					"time": 420,
					"message": "Today I learned that single board computers don't need a GUI."
				},
				{
					"time": 437,
					"message": "Today I learned that you can block all ads on your home network with @The_Pi_Hole"
				},
				{
					"time": 517,
					"message": "Today I learned the difference between a single board computer and a microcontroller!"
				},
				{
					"time": 653,
					"message": "Today I learned there's other single board computers like the @tesselproject 2."
				},
				{
					"time": 708,
					"message": "Today I learned some singleboard computers have ethernet and USB ports and GPIO pins."
				},
				{
					"time": 824,
					"message": "Today I learned that the @tesselproject was originally targeted at JavaScript developers."
				},
				{
					"time": 838,
					"message": "Today I learned some single board computers don't require an SD card."
				},
				{
					"time": 903,
					"message": "Today I learned that it's not that difficult to install an OS on an SD card."
				},
				{
					"time": 968,
					"message": "Today I learned that you can get cases in all sorts of configurations for single board computers"
				},
				{
					"time": 1000,
					"message": "Today I learned that people attach @raspberry_pi computers to their TVs with VESA mounts"
				},
				{
					"time": 1040,
					"message": "Today I learned that it's as simple as plugging in a Wifi dongle to older @raspberry_pi to get it connected wirelessly"
				},
				{
					"time": 1055,
					"message": "Today I learned you can 3D print @raspberry_pi cases! Cool!"
				},
				{
					"time": 1080,
					"message": "Today I learned you can add screens, cameras and other 'hats' to the @raspberry_pi"
				},
				{
					"time": 1150,
					"message": "Today I learned you can get a bunch of sensors and outputs in one hat for the @raspberry_pi called the Matrix One Creator"
				},
				{
					"time": 1380,
					"message": "Today I learned you can use 'machine learning' on a @raspberry_pi to recognize gestures and faces"
				},
				{
					"time": 1480,
					"message": "TIL: You can create a time lapse camera using a @raspberry_pi. Project by @adafruit's @ecken & @videopixil"
				},
				{
					"time": 1560,
					"message": "Today I learned that I don't need to come up with a project all by myself. I can follow tutorials."
				},
				{
					"time": 1630,
					"message": "Today I learned you can build your own games console with a @raspberry_pi. Project by @ecken & @videopixil"
				},
				{
					"time": 1740,
					"message": "Today I learned not to take legal advice from @craigsdennis and @chalkers!"
				},
				{
					"time": 1880,
					"message": "Today I learned how NOT to shut down a @raspberry_pi."
				},
				{
					"time": 1915,
					"message": "Today I learned that maker projects take time and patience and that things can go wrong!"
				},
				{
					"time": 1970,
					"message": "Today I learned, even with a tutorial there's still room for trial & error learning opportunites"
				},
				{
					"time": 2095,
					"message": "Today I learned that a great first project is the @The_Pi_Hole that blocks ads on my home network"
				},
				{
					"time": 2145,
					"message": "Today I learned what a timelapse looks like taken on a @raspberry_pi zero and Raspberry Pi camera"
				}
			],
			"gallery": [
				{
					"src": "/images/S01E03/thumb/img-0.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-0.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-1.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-1.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-2.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-2.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-3.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-3.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-4.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-4.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-5.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-5.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-6.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-6.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-7.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-7.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-8.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-8.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-9.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-9.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-10.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-10.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-11.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-11.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-12.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-12.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-13.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-13.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-14.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-14.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-15.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-15.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-16.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-16.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-17.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-17.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-18.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-18.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-19.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-19.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-20.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-20.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-21.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-21.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-22.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-22.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-23.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-23.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-24.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-24.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-25.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-25.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-26.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-26.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-27.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-27.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-28.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-28.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-29.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-29.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-30.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-30.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-31.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-31.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-32.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-32.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-33.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-33.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-34.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-34.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-35.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-35.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-36.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-36.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-37.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-37.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-38.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-38.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-39.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-39.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-40.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-40.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-41.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-41.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-42.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-42.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-43.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-43.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-44.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-44.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-45.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-45.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-46.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-46.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-47.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-47.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-48.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-48.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-49.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-49.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-50.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-50.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-51.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-51.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-52.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-52.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-53.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-53.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-54.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-54.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-55.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-55.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-56.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-56.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-57.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-57.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-58.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-58.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-59.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-59.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-60.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-60.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-61.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-61.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-62.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-62.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-63.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-63.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-64.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-64.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-65.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-65.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-66.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-66.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-67.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-67.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-68.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-68.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-69.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-69.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-70.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-70.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-71.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-71.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-72.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-72.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-73.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-73.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-74.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-74.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-75.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-75.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-76.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-76.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-77.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-77.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-78.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-78.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-79.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-79.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-80.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-80.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-81.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-81.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-82.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-82.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-83.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-83.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-84.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-84.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-85.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-85.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-86.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-86.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-87.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-87.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-88.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-88.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-89.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-89.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-90.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-90.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-91.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-91.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-92.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-92.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-93.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-93.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-94.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-94.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-95.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-95.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-96.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-96.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-97.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-97.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-98.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-98.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-99.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-99.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-100.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-100.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-101.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-101.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-102.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-102.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-103.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-103.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-104.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-104.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-105.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-105.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-106.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-106.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-107.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-107.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-108.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-108.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-109.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-109.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-110.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-110.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-111.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-111.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-112.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-112.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-113.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-113.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-114.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-114.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-115.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-115.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-116.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-116.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-117.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-117.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				},
				{
					"src": "/images/S01E03/thumb/img-118.jpg",
					"lightboxImage": {
						"src": "/images/S01E03/large/img-118.jpg"
					},
					"width": 150,
					"height": 84,
					"aspectRatio": 1.7857
				}
			]
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/episodes.json
 ** module id = 138
 ** module chunks = 0
 **/